export default function Error() {
  return <div>Une erreur s'est produite</div>
}
